import { SearchUser } from 'lib-search-types';
import { v4 as uuidv4 } from 'uuid';

import { getUserDisplayName } from 'utils/user';

const nonBreakingSpace = '&nbsp;';

export const dataUserIdAttribute = 'data-user-id';

export const createMentionSpan = (
  user: SearchUser,
): { id: string; content: string } => {
  const mentionId = uuidv4();
  return {
    id: mentionId,
    // Set contenteditable="false" to prevent styling changes.
    content: `<span class="mention" contenteditable="false" ${dataUserIdAttribute}="${
      user.id
    }" data-mention-id="${mentionId}">@${getUserDisplayName(
      user,
    )}</span>${nonBreakingSpace}`,
  };
};

/**
 * Positions the caret after the mention
 *
 * @param editor
 * @param mentionId
 */
export const moveCaretAfterMention = (
  editor: HTMLDivElement | null,
  mentionId: string,
): void => {
  const selection = document.getSelection();
  if (!editor || !selection) {
    return;
  }

  const elm = editor.querySelector(
    `span.mention[data-mention-id="${mentionId}"]`,
  );
  if (!elm?.nextSibling) {
    return;
  }

  const range = document.createRange();
  // nextSibling is the nonBreakingSpace textNode
  range.setStart(elm.nextSibling, elm.nextSibling.textContent?.length ?? 0);
  range.setEnd(elm.nextSibling, elm.nextSibling.textContent?.length ?? 0);
  selection.removeAllRanges();
  selection.addRange(range);
};

export const shouldHandleSelectionChange = (
  selection: Selection | null,
): boolean => {
  const parentNode = selection?.anchorNode?.parentNode;

  return (
    parentNode?.nodeName !== 'SPAN' ||
    !(parentNode as Element).classList?.contains('mention') ||
    !(parentNode as Element).getAttribute(dataUserIdAttribute)
  );
};
